import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-35f88d08")
const _hoisted_1 = { class: "ticket" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = {
  class: "p-col-12 p-sm-2",
  style: {"display":"grid","place-items":"center"}
}
const _hoisted_5 = { class: "p-col" }
const _hoisted_6 = { class: "p-field p-col" }
const _hoisted_7 = { class: "p-field p-col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-truck-moving" }, null, -1)
const _hoisted_9 = { class: "p-grid" }
const _hoisted_10 = {
  class: "p-col-12 p-sm-2",
  style: {"display":"grid","place-items":"center"}
}
const _hoisted_11 = { class: "p-col" }
const _hoisted_12 = { class: "p-field p-col" }
const _hoisted_13 = { class: "p-field p-col" }
const _hoisted_14 = { class: "p-field p-col" }
const _hoisted_15 = { class: "p-field p-col" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone p-mr-2" }),
  /*#__PURE__*/_createElementVNode("span", null, "Emergency Contact")
], -1)
const _hoisted_17 = { class: "p-grid" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-key" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file" }, null, -1)
const _hoisted_20 = {
  class: "p-d-flex p-jc-around",
  style: {"gap":"3rem"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_22 = { class: "p-grid" }
const _hoisted_23 = {
  class: "p-col-12 p-sm-2",
  style: {"display":"grid","place-items":"center"}
}
const _hoisted_24 = { style: {"width":"clamp(100px, 100%, 180px)","aspect-ratio":"1"} }
const _hoisted_25 = { class: "p-col-12 p-sm-10" }
const _hoisted_26 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_27 = { class: "p-field p-col" }
const _hoisted_28 = { class: "p-field p-col" }
const _hoisted_29 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_30 = { class: "p-field p-col" }
const _hoisted_31 = { class: "p-field p-col" }
const _hoisted_32 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_33 = { class: "p-field p-col" }
const _hoisted_34 = { class: "p-field p-col" }
const _hoisted_35 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_36 = { class: "p-field p-col" }
const _hoisted_37 = { class: "p-field p-col" }
const _hoisted_38 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_39 = { class: "p-field p-col" }
const _hoisted_40 = { class: "p-field p-col" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-truck-moving" }, null, -1)
const _hoisted_42 = { class: "p-grid" }
const _hoisted_43 = {
  class: "p-col-12 p-sm-2",
  style: {"display":"grid","place-items":"center"}
}
const _hoisted_44 = { style: {"width":"clamp(100px, 100%, 180px)","aspect-ratio":"1"} }
const _hoisted_45 = { class: "p-col" }
const _hoisted_46 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_47 = { class: "p-field p-col" }
const _hoisted_48 = { class: "p-field p-col" }
const _hoisted_49 = { class: "p-field p-col" }
const _hoisted_50 = { class: "p-field p-col" }
const _hoisted_51 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_52 = { class: "p-field p-col" }
const _hoisted_53 = { class: "p-field p-col" }
const _hoisted_54 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_55 = { class: "p-field-checkbox" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { for: "enable_self_accept" }, "Enable self accept WRS", -1)
const _hoisted_57 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_58 = { class: "p-field p-col" }
const _hoisted_59 = { class: "p-mb-3 p-d-flex p-align-center" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("strong", { class: "p-mr-1" }, "Email validated:", -1)
const _hoisted_61 = {
  key: 0,
  class: "p-field p-fluid"
}
const _hoisted_62 = { class: "p-field p-fluid" }
const _hoisted_63 = { class: "p-field p-fluid" }
const _hoisted_64 = { class: "p-d-flex p-ai-center" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone p-mr-2" }, null, -1)
const _hoisted_66 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_67 = { class: "p-field p-col" }
const _hoisted_68 = { class: "p-field p-col" }
const _hoisted_69 = { class: "p-field p-col" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-key" }, null, -1)
const _hoisted_71 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  style: {"opacity":"0","position":"absolute","top":"-1000px"}
}, null, -1)
const _hoisted_73 = { class: "p-field p-col" }
const _hoisted_74 = { class: "p-field p-col" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file" }, null, -1)
const _hoisted_76 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_77 = { class: "p-field p-col p-text-center p-d-flex p-jc-center" }
const _hoisted_78 = { style: {"width":"150px"} }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("h5", { class: "p-text-nowrap" }, "Upload Truck License", -1)
const _hoisted_80 = { class: "p-field p-col p-text-center p-d-flex p-jc-center" }
const _hoisted_81 = { style: {"width":"150px"} }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("h5", { class: "p-text-nowrap" }, "Upload Insurance", -1)
const _hoisted_83 = ["href"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_ImageInput = _resolveComponent("ImageInput")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_StateAutocomplete = _resolveComponent("StateAutocomplete")!
  const _component_UserRoleSelect = _resolveComponent("UserRoleSelect")!
  const _component_CompanyAutocomplete = _resolveComponent("CompanyAutocomplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_YesNo = _resolveComponent("YesNo")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Divider = _resolveComponent("Divider")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.requestPending && !_ctx.user)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Fieldset, { class: "p-fluid p-my-3" }, {
            legend: _withCtx(() => [
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Skeleton, {
                    height: "12rem",
                    width: "12rem",
                    class: "p-mb-2"
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                    return _createElementVNode("div", {
                      class: "p-fluid p-formgrid p-grid",
                      key: i
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_Skeleton, {
                          height: "2rem",
                          class: "p-mb-2"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_Skeleton, {
                          height: "2rem",
                          class: "p-mb-2"
                        })
                      ])
                    ])
                  }), 64))
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-fluid p-my-3" }, {
            legend: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Skeleton, {
                    height: "12rem",
                    width: "12rem",
                    class: "p-mb-2"
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
                    return _createElementVNode("div", {
                      class: "p-fluid p-formgrid p-grid",
                      key: i
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_Skeleton, {
                          height: "2rem",
                          class: "p-mb-2"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_Skeleton, {
                          height: "2rem",
                          class: "p-mb-2"
                        })
                      ])
                    ])
                  }), 64))
                ])
              ])
            ]),
            _: 1
          }),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (i) => {
            return _createElementVNode("div", {
              class: "p-fluid p-formgrid p-grid",
              key: i
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  class: "p-mb-2"
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  class: "p-mb-2"
                })
              ])
            ])
          }), 64)),
          _createVNode(_component_Skeleton, {
            height: "3.5rem",
            class: "p-mb-2"
          }),
          _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_16
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  class: "p-col"
                }),
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  class: "p-col"
                }),
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  class: "p-col"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_18
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Skeleton, {
                height: "2rem",
                class: "p-mb-2"
              }),
              _createVNode(_component_Skeleton, {
                height: "2rem",
                class: "p-mb-2"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
            legend: _withCtx(() => [
              _hoisted_19
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_Skeleton, {
                  height: "200px",
                  width: "200px"
                }),
                _createVNode(_component_Skeleton, {
                  height: "200px",
                  width: "200px"
                })
              ])
            ]),
            _: 1
          })
        ], 64))
      : (_ctx.user)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_Fieldset, {
              class: "p-mb-3",
              disabled: _ctx.isReadOnly
            }, {
              legend: _withCtx(() => [
                _hoisted_21
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_ImageInput, {
                        id: "avatar",
                        name: "avatar",
                        modelValue: _ctx.user.avatarFileToUpload,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.user.avatarFileToUpload = $event)),
                        url: _ctx.user.avatar_image_path_url
                      }, null, 8, ["modelValue", "url"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.first_name')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.name,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.name = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.last_name')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.surname,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.surname = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.email')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.email,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.user.email = $event)),
                              type: "email"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.phone')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.phone,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.user.phone = $event)),
                              type: "tel"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_StateAutocomplete, {
                          modelValue: _ctx.selectedState,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedState = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.city')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.city,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.user.city = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.address')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.address,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.user.address = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.zip')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.zip,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.user.zip = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.role')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_UserRoleSelect, {
                              multi: true,
                              modelValue: _ctx.user.role,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.user.role = $event)),
                              disabled: _ctx.isReadOnly
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.company_name')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.company_name,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.user.company_name = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_Fieldset, {
              class: "p-mb-3",
              disabled: _ctx.isReadOnly
            }, {
              legend: _withCtx(() => [
                _hoisted_41
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_ImageInput, {
                        id: "truck_image",
                        name: "truck_image",
                        modelValue: _ctx.user.truckFileToUpload,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.user.truckFileToUpload = $event)),
                        url: _ctx.user.truck_image_path_url
                      }, null, 8, ["modelValue", "url"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.truck_info')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.truck_information,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.user.truck_information = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.truck_tag')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.truck_tag,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.user.truck_tag = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.driver_license')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.license_number,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.user.license_number = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.cdl_license')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.cdl_license,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.user.cdl_license = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_CompanyAutocomplete, {
                          modelValue: _ctx.user.broker,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.user.broker = $event)),
                          type: 400,
                          label: "Broker",
                          onSelect: _ctx.onBrokerSelected
                        }, null, 8, ["modelValue", "onSelect"]),
                        (!_ctx.user.broker)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              type: "button",
                              label: "Create and assign broker",
                              class: "p-mt-3 p-button-outlined w-auto",
                              loading: _ctx.requestPending,
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.assignBroker()))
                            }, null, 8, ["loading"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_FloatLabel, {
                          label: _ctx.$t('user.usdot_number')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.user.usdot_number,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.user.usdot_number = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_Checkbox, {
                          id: "enable_self_accept",
                          modelValue: _ctx.user.enable_self_accept,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.user.enable_self_accept = $event)),
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_56
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_Button, {
                  icon: "fas fa-stream",
                  label: "Live Stream",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.goToLive()))
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('user.status')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Dropdown, {
                      modelValue: _ctx.user.status,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.user.status = $event)),
                      options: _ctx.statusOptions,
                      optionLabel: "label",
                      optionValue: "value",
                      disabled: _ctx.isReadOnly
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              _createVNode(_component_YesNo, {
                value: _ctx.user.is_email_validated
              }, null, 8, ["value"]),
              (!_ctx.user.is_email_validated)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    loading: _ctx.requestPending,
                    type: "button",
                    label: "Resend Email",
                    class: "p-ml-2 p-button-outlined w-auto",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.resendEmail()))
                  }, null, 8, ["loading"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.canViewPrivateNote)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createVNode(_component_FloatLabel, {
                    label: _ctx.$t('user.private_note')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Textarea, {
                        autoResize: true,
                        modelValue: _ctx.user.note_private,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.user.note_private = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_62, [
              _createVNode(_component_FloatLabel, {
                label: _ctx.$t('user.reg_customer')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Textarea, {
                    autoResize: true,
                    modelValue: _ctx.user.reg_customer,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.user.reg_customer = $event)),
                    disabled: _ctx.isReadOnly
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_FloatLabel, {
                label: _ctx.$t('user.reg_broker')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Textarea, {
                    autoResize: true,
                    modelValue: _ctx.user.reg_broker,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.user.reg_broker = $event)),
                    disabled: _ctx.isReadOnly
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode(_component_Fieldset, {
              class: "p-fluid p-mb-3",
              disabled: _ctx.isReadOnly
            }, {
              legend: _withCtx(() => [
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, 'user.emergency_contact_title']
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createVNode(_component_FloatLabel, {
                      label: _ctx.$t('user.emergency_name')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.user.emergency_name,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.user.emergency_name = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_FloatLabel, {
                      label: _ctx.$t('user.emergency_phone')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.user.emergency_phone,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.user.emergency_phone = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_component_FloatLabel, {
                      label: _ctx.$t('user.emergency_email')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.user.emergency_email,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.user.emergency_email = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_Fieldset, {
              class: "p-fluid",
              disabled: _ctx.isReadOnly
            }, {
              legend: _withCtx(() => [
                _hoisted_70
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _createElementVNode("div", _hoisted_73, [
                    _createVNode(_component_FloatLabel, { label: "Password" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          autocomplete: "new-password",
                          modelValue: _ctx.user.password,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.user.password = $event)),
                          type: "password"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createVNode(_component_FloatLabel, { label: "Confirm password" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputText, {
                          autocomplete: "new-password",
                          modelValue: _ctx.user.confirmPassword,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.user.confirmPassword = $event)),
                          type: "password"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_Fieldset, {
              class: "p-mt-3",
              disabled: _ctx.isReadOnly
            }, {
              legend: _withCtx(() => [
                _hoisted_75
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _createVNode(_component_ImageInput, {
                        id: "license",
                        name: "license",
                        modelValue: _ctx.user.licenseFileToUpload,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.user.licenseFileToUpload = $event))
                      }, null, 8, ["modelValue"]),
                      (_ctx.hasLicenseFile)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "javascript:void(0)",
                            onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.downloadLicenseFile && _ctx.downloadLicenseFile(...args)))
                          }, " Download license file "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _hoisted_82,
                      _createVNode(_component_ImageInput, {
                        id: "insurance",
                        name: "insurance",
                        modelValue: _ctx.user.insuranceFileToUpload,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.user.insuranceFileToUpload = $event))
                      }, null, 8, ["modelValue"]),
                      (_ctx.hasInsuranceFile)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _ctx.user.insurance_image_path_url
                          }, " Download insurance file ", 8, _hoisted_83))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_Divider)
          ], 64))
        : _createCommentVNode("", true)
  ]))
}